<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="办事处" v-if="isFiltration">
                    <!-- <el-select v-model="params.RegionalID" placeholder="请选择大区" class="el-select-medium" @change="onSelectdata">
                        <el-option label="请选择大区" :value="0"></el-option>
                        <el-option v-for="item in regionoptions" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                    </el-select> -->
                    <el-select v-model="params.BranceOfficeCode" placeholder="请选择办事处" class="el-select-medium" style="margin-left: 5px">
                        <el-option label="请选择办事处" value=""></el-option>
                        <el-option v-for="item in officeoptions" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务员" v-if="isFiltration">
                    <el-input autocomplete="on" name="BranceOfficeMemerCode"  v-model="params.BranceOfficeMemerCode" placeholder="请输入业务员编号,名称" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="合同号">
                    <el-input  autocomplete="on" name="OrderSN" v-model="params.OrderSN" placeholder="请输入合同号" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="客户名称">
                    <el-input  autocomplete="on" name="CustomerName" v-model="params.CustomerName" placeholder="请输入客户名称" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="工程名称">
                    <el-input  autocomplete="on" name="ProjectName" v-model="params.ProjectName" placeholder="请输入工程名称" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="审核超时">
                    <el-select v-model="params.DelayState" placeholder="请选择" class="el-select-medium" clearable style="width: 100px">
                        <el-option v-for="item in DelayState_List" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="BPM审核状态">
                    <el-select v-model="params.BPMstate" placeholder="请选择" class="el-select-medium" style="width: 120px" clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getTableList(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                合同业务划分规则管理
                <span>
                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getExport()">导出查询信息(最多5000条)</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="tableData" :height="maxheight" ref="multipleTable" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">

                <el-table-column prop="DistributeMain_OrdersSN" label="合同号" show-overflow-tooltip width="160" align="center"></el-table-column>
                <el-table-column prop="DistributeMain_OrdersCustomerName" label="客户名称" width="180" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="DistributeMain_ProjectName" label="工程名称" align="left" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="DistributeMain_OrdersOfficeManName" label="业务员" width="150" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="DistributeMain_OrdersOfficeCode" label="办事处" width="150" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="DistributeMain_AuditTimeOut" label="超时时长" width="150" show-overflow-tooltip align="center"></el-table-column>

                <el-table-column prop="DistributeMain_BPMStatusName" label="审核状态" width="120" show-overflow-tooltip align="center">
                    <template v-slot="scope">
                        <span :class="judgeColor(scope.row.DistributeMain_BPMStatusName)">{{ scope.row.DistributeMain_BPMStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DistributeMain_AuditTime" label="业绩划分BAM审核通过" show-overflow-tooltip width="150" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.DistributeMain_AuditTime.indexOf('0001') >= 0"></span>
                        <span v-else>{{ scope.row.DistributeMain_AuditTime | formatDates }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DistributeMain_AddTime" label="合同BAM审核通过" show-overflow-tooltip width="140" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.DistributeMain_AddTime | formatDates }}
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="center" width="120" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">查看</span>
                            <span v-if="scope.row.EditState == 'true' || scope.row.EditTip == 'true'" class="operation-bar-block" @click="openAppend(2, scope.row)">编辑</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <manageDetails :isdetailFlag="isdetailFlag" :isSPCOrder="true" @handleClose="handleClose" :id="id" />
        <appendDistribute :isAppendAdd="isAppendAdd" @onClose="onClose" :status="type" :id="id" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import manageDetails from './components/manageDetails.vue';
import appendDistribute from './components/appendDistribute.vue';
import { formatDate, downloadFile } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
export default {
    name: 'contractperformance',
    mixins: [myMixin],
    components: {
        Pagination,
        manageDetails,
        appendDistribute
    },
    data() {
        return {
            isdetailFlag: false,
            isAppendAdd: false,
            loadingBtn: false,
            id: 0,
            type: 1,
            params: {
                BranceOfficeMemerCode: '', //业务员
                OrderSN: '', //合同号
                ProjectName: '', //工程名称
                CustomerName: '', //客户名称
                DelayState: '', //审核超时
                BPMstate: '', //BPM审核状态
                startDate: '', //开始时间
                endDate: '', //结束时间
                BranceOfficeCode: '' //办事处
            },
            timer: [],
            tableData: [],
            officeoptions: [],
            regionoptions: [],
            options: [
                { value: 0, label: '线下' },
                { value: 1, label: '商城' },
                { value: 2, label: '代客下单' }
            ],
            options1: [
                { value: 0, label: '待送审' },
                { value: 1, label: '审核中' },
                { value: 2, label: '已通过' },
                { value: 3, label: '未通过' },
                { value: -1, label: '送审失败' }
            ],
            options2: [
                { value: 0, label: '待送审' },
                { value: 1, label: '已通过' },
                { value: 2, label: '未通过' }
            ],
            options3: [
                { value: 0, label: '正常' },
                { value: 1, label: '异常' }
            ],
            DelayState_List: [
                { name: '全部', value: 0 },
                { name: '未超时', value: 1 },
                { name: '已超时', value: 2 }
            ]
        };
    },
    mounted() {
        this.getLargeRegions();
        this.getBranchOffices();
        this.getTableList();
    },
    methods: {
        onRefresh() {
            this.params = {
                RegionalID: 0,
                BranceOfficeCode: '',
                BranceOfficeMemerCode: '',
                ERPOrderSN: '',
                OrderSN: '',
                Distribute_OrderType: '',
                ProjectName: '',
                BPMstate: '',
                State: '',
                startDate: '',
                endDate: '',
                DistributeMain_IsInvalid: ''
            };
            this.timer = [];
            this.officeoptions = [];
            this.regionoptions = [];
            this.getLargeRegions();
            this.getBranchOffices();
            this.getTableList(true);
        },
        getTableList(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getSPCOrdersPerformanceDistributeMainsGroup(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;

                        this.paginationOptions.total = res.data.RecordCount;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = { ...this.params };
            if (this.timer && this.timer.length > 0) {
                params.startDate = this.timer[0];
                params.endDate = this.timer[1];
            }
            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        getExport() {
            this.$newsApi.GetSPCOrdersPerformanceDistributeMainsGroupExport(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        openAppend(type, row) {
            console.log(type, row);
            this.type = type;
            if (this.type == 2) {
                this.id = row.DistributeMain_ID;
            }
            this.isAppendAdd = true;
        },

        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getTableList();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getTableList();
        },
        onSelectdata(e) {
            console.log(e, 'eeeeeeeee');
            this.BranceOfficeCode = 0;
            this.getBranchOffices();
        },
        //获取全部大区
        getLargeRegions() {
            this.$newsApi.common.getLargeRegions().then((res) => {
                if (res.data.Resultcode == 0 && res.data.data) {
                    this.regionoptions = res.data.data;
                }
            });
        },
        //获取根据大区获取办事处列表
        getBranchOffices() {
            this.$newsApi.common.getBranchOffices({ RegionalID: 0 }).then((res) => {
                if (res.data.Resultcode == 0 && res.data.data) {
                    this.officeoptions = res.data.data;
                }
            });
        },
        handleViewsDetail(row) {
            this.isdetailFlag = true;
            this.id = row.DistributeMain_ID;
            console.log(row);
        },
        handleClose() {
            this.isdetailFlag = false;
        },
        onClose(flag) {
            if (flag) {
                this.onRefresh();
            }
            this.isAppendAdd = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>